import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_backoffice/klb-petani/')({
  beforeLoad: () => {
    throw redirect({
      to: '/klb-petani/petani'
    })
  }
})
